// extracted by mini-css-extract-plugin
module.exports = {"container":"ComputationResult_container__rgEGO"};